const TEXTS = {
  "en": {
    "welcome": {
      "subtitle": "Take this 60-second quiz to find the dating app that fits you",
      "cta": "Start the Quiz",
      "laurels": [
        "Editor's choice",
        "User's choice",
        "Best choice"
      ],
      "ofTheYear": "of the year"
    },
    "header": {
      "unlock": {
        "title": "Your perfect dating app is inside 🔒",
        "subtitle": "Answer a few questions to unlock it"
      },
      "ready": {
        "title": "Your result is almost ready 🎉",
        "subtitle": "Preparing your result"
      }
    },
    "dating_experience": {
      "title": "Have you tried online dating before?",
      "subtitle": "It can be changed later",
      "answers": [
        "No",
        "Yes"
      ]
    },
    "nearby": {
      "title": "Would you prefer to meet someone nearby?",
      "subtitle": "It can be changed later",
      "answers": [
        "No",
        "Yes"
      ]
    },
    "goal": {
      "title": "What are you looking for?",
      "subtitle": "It can be changed later",
      "answers": [
        "Flirting and having fun",
        "Making new friends",
        "Finding a life partner",
        "Meeting people my own age",
        "Not sure yet"
      ]
    },
    "age_difference": {
      "title": "Does age difference matter to you?",
      "subtitle": "It can be changed later",
      "answers": [
        "I prefer someone close to my age",
        "A small age gap is fine",
        "Age doesn't matter much",
        "I'm open to anything"
      ]
    },
    "payment": {
      "title": "Are you willing to pay for dating site services?",
      "answers": [
        "Absolutely not",
        "Depends on features",
        "Yes",
        "Hard to say"
      ]
    },
    "important": {
      "title": "What matters most to you on a dating site?",
      "subtitle": "You can choose multiple answers",
      "answers": [
        "Prices",
        "Amount of features",
        "User interface convenience",
        "I'm not sure yet"
      ]
    },
    "faith": {
      "title": "How important is shared faith in a relationship?",
      "answers": [
        "🙏 Very important",
        "🤍 Important, but not a must",
        "🌿 I’m open to different beliefs"
      ]
    },
    "share": {
      "title": "What would you most like to share with a partner?",
      "answers": [
        "🙏 Prayer and spiritual growth",
        "⛪ Church and community life",
        "🤍 Everyday care and support",
        "🏡 Family traditions and values"
      ]
    },
    "distance": {
      "title": "Would you prefer to meet someone nearby?",
      "answers": [
        "📍 Yes, preferably nearby",
        "🌍 Farther away is fine"
      ]
    },
    "next": "Next",
    "loader": [
      "Analyzing your answers…",
      "Comparing dating apps…",
      "Preparing your result…"
    ],
    "final": {
      "title": "Here's what we recommend for you:",
      "cta": "Visit Kismia"
    },
    "shortFinal": {
      "title": "See what’s next! 🎉",
      "subtitle": "The answers have been processed!",
      "cta": "Continue"
    },
    "footer": {
      "about": "About us",
      "privacy": "Privacy Policy",
      "terms": "Terms of Use"
    }
  },
  "de": {
    "welcome": {
      "subtitle": "Mach dieses 60-Sekunden-Quiz und finde die Dating-App, die zu dir passt",
      "cta": "Quiz starten",
      "laurels": [
        "Wahl der Redaktion",
        "Wahl der Nutzer",
        "Beste Wahl"
      ],
      "ofTheYear": "des Jahres"
    },
    "header": {
      "unlock": {
        "title": "Deine perfekte Dating-App wartet hier 🔒",
        "subtitle": "Beantworte ein paar Fragen, um sie freizuschalten"
      },
      "ready": {
        "title": "Dein Ergebnis ist fast fertig 🎉",
        "subtitle": "Dein Ergebnis wird vorbereitet"
      }
    },
    "dating_experience": {
      "title": "Hast du schon einmal Online-Dating ausprobiert?",
      "subtitle": "Du kannst es später ändern",
      "answers": [
        "Nein",
        "Ja"
      ]
    },
    "nearby": {
      "title": "Möchtest du lieber jemanden in deiner Nähe kennenlernen?",
      "subtitle": "Du kannst es später ändern",
      "answers": [
        "Nein",
        "Ja"
      ]
    },
    "goal": {
      "title": "Wonach suchst du?",
      "subtitle": "Du kannst es später ändern",
      "answers": [
        "Flirten und Spaß haben",
        "Neue Freunde finden",
        "Einen Partner fürs Leben finden",
        "Leute in meinem Alter kennenlernen",
        "Noch nicht sicher"
      ]
    },
    "age_difference": {
      "title": "Ist dir der Altersunterschied wichtig?",
      "subtitle": "Du kannst es später ändern",
      "answers": [
        "Ich bevorzuge jemanden in meinem Alter",
        "Ein kleiner Altersunterschied ist okay",
        "Das Alter spielt keine große Rolle",
        "Ich bin für alles offen"
      ]
    },
    "payment": {
      "title": "Bist du bereit, für die Dienste einer Dating-Seite zu bezahlen?",
      "answers": [
        "Auf keinen Fall",
        "Kommt auf die Funktionen an",
        "Ja",
        "Schwer zu sagen"
      ]
    },
    "important": {
      "title": "Was ist dir bei einer Dating-Seite am wichtigsten?",
      "subtitle": "Du kannst mehrere Antworten auswählen",
      "answers": [
        "Preise",
        "Funktionsumfang",
        "Einfache Bedienung",
        "Weiß ich noch nicht"
      ]
    },
    "faith": {
      "title": "Wie wichtig ist dir ein gemeinsamer Glaube in einer Beziehung?",
      "answers": [
        "🙏 Sehr wichtig",
        "🤍 Wichtig, aber kein Muss",
        "🌿 Ich bin offen für andere Überzeugungen"
      ]
    },
    "share": {
      "title": "Was möchtest du am liebsten mit einem Partner teilen?",
      "answers": [
        "🙏 Gebet und spirituelles Wachstum",
        "⛪ Kirche und Gemeindeleben",
        "🤍 Fürsorge und Unterstützung im Alltag",
        "🏡 Familientraditionen und Werte"
      ]
    },
    "distance": {
      "title": "Möchtest du lieber jemanden in deiner Nähe kennenlernen?",
      "answers": [
        "📍 Ja, am liebsten in der Nähe",
        "🌍 Auch weiter weg ist okay"
      ]
    },
    "next": "Weiter",
    "loader": [
      "Deine Antworten werden analysiert…",
      "Dating-Apps werden verglichen…",
      "Dein Ergebnis wird vorbereitet…"
    ],
    "final": {
      "title": "Das empfehlen wir dir:",
      "cta": "Kismia besuchen"
    },
    "shortFinal": {
      "title": "Schau, was als Nächstes kommt! 🎉",
      "subtitle": "Deine Antworten wurden verarbeitet!",
      "cta": "Weiter"
    },
    "footer": {
      "about": "Über uns",
      "privacy": "Datenschutzerklärung",
      "terms": "Nutzungsbedingungen"
    }
  },
  "es": {
    "welcome": {
      "subtitle": "Haz este quiz de 60 segundos y encuentra la app de citas ideal para ti",
      "cta": "Comenzar el quiz",
      "laurels": [
        "Elección del editor",
        "Elección de los usuarios",
        "Mejor elección"
      ],
      "ofTheYear": "del año"
    },
    "header": {
      "unlock": {
        "title": "Tu app de citas perfecta está aquí dentro 🔒",
        "subtitle": "Responde unas preguntas para desbloquearla"
      },
      "ready": {
        "title": "Tu resultado está casi listo 🎉",
        "subtitle": "Preparando tu resultado"
      }
    },
    "dating_experience": {
      "title": "¿Ya has experimentado las citas online?",
      "subtitle": "Puedes cambiarlo después",
      "answers": [
        "No",
        "Sí"
      ]
    },
    "nearby": {
      "title": "¿Prefieres conocer a alguien cerca de ti?",
      "subtitle": "Puedes cambiarlo después",
      "answers": [
        "No",
        "Sí"
      ]
    },
    "goal": {
      "title": "¿Qué buscas?",
      "subtitle": "Puedes cambiarlo después",
      "answers": [
        "Coquetear y divertirme",
        "Hacer nuevos amigos",
        "Encontrar una pareja para toda la vida",
        "Conocer gente de mi edad",
        "Aún no lo sé"
      ]
    },
    "age_difference": {
      "title": "¿Te importa la diferencia de edad?",
      "subtitle": "Puedes cambiarlo después",
      "answers": [
        "Prefiero a alguien cercano a mi edad",
        "Una pequeña diferencia de edad está bien",
        "La edad no importa mucho",
        "No me cierro a nada"
      ]
    },
    "payment": {
      "title": "¿Pagarías por los servicios de un sitio de citas?",
      "answers": [
        "Para nada",
        "Depende de las funciones",
        "Sí",
        "Difícil de decir"
      ]
    },
    "important": {
      "title": "¿Qué es lo más importante para ti en un sitio de citas?",
      "subtitle": "Puedes elegir varias respuestas",
      "answers": [
        "Precios",
        "Cantidad de funciones",
        "Interfaz fácil de usar",
        "Aún no lo sé"
      ]
    },
    "faith": {
      "title": "¿Qué importancia tiene para ti compartir la misma fe en una relación?",
      "answers": [
        "🙏 Muy importante",
        "🤍 Importante, pero no imprescindible",
        "🌿 Tengo la mente abierta a otras creencias"
      ]
    },
    "share": {
      "title": "¿Qué es lo que más te gustaría compartir con tu pareja?",
      "answers": [
        "🙏 Oración y crecimiento espiritual",
        "⛪ Vida de iglesia y comunidad",
        "🤍 Cuidado y apoyo en el día a día",
        "🏡 Tradiciones y valores familiares"
      ]
    },
    "distance": {
      "title": "¿Prefieres conocer a alguien cerca de ti?",
      "answers": [
        "📍 Sí, mejor cerca de mí",
        "🌍 Más lejos también está bien"
      ]
    },
    "next": "Siguiente",
    "loader": [
      "Analizando tus respuestas…",
      "Comparando apps de citas…",
      "Preparando tu resultado…"
    ],
    "final": {
      "title": "Esto es lo que te recomendamos:",
      "cta": "Visitar Kismia"
    },
    "shortFinal": {
      "title": "¡Mira lo que sigue! 🎉",
      "subtitle": "¡Tus respuestas han sido procesadas!",
      "cta": "Continuar"
    },
    "footer": {
      "about": "Sobre nosotros",
      "privacy": "Política de privacidad",
      "terms": "Términos de uso"
    }
  },
  "fr": {
    "welcome": {
      "subtitle": "Réponds à ce quiz de 60 secondes pour trouver l'appli de rencontre faite pour toi",
      "cta": "Commencer le quiz",
      "laurels": [
        "Choix de la rédaction",
        "Choix des utilisateurs",
        "Meilleur choix"
      ],
      "ofTheYear": "de l'année"
    },
    "header": {
      "unlock": {
        "title": "Ton appli de rencontre idéale t'attend ici 🔒",
        "subtitle": "Réponds à quelques questions pour la débloquer"
      },
      "ready": {
        "title": "Ton résultat est bientôt prêt 🎉",
        "subtitle": "On prépare ton résultat"
      }
    },
    "dating_experience": {
      "title": "Tu as déjà essayé les rencontres en ligne ?",
      "subtitle": "Tu pourras le modifier plus tard",
      "answers": [
        "Non",
        "Oui"
      ]
    },
    "nearby": {
      "title": "Tu préfères rencontrer quelqu'un près de chez toi ?",
      "subtitle": "Tu pourras le modifier plus tard",
      "answers": [
        "Non",
        "Oui"
      ]
    },
    "goal": {
      "title": "Qu'est-ce que tu cherches ?",
      "subtitle": "Tu pourras le modifier plus tard",
      "answers": [
        "Flirter et m'amuser",
        "Me faire de nouveaux amis",
        "Trouver l'âme sœur",
        "Rencontrer des gens de mon âge",
        "Je ne sais pas encore"
      ]
    },
    "age_difference": {
      "title": "La différence d'âge compte pour toi ?",
      "subtitle": "Tu pourras le modifier plus tard",
      "answers": [
        "Je préfère quelqu'un proche de mon âge",
        "Un petit écart d'âge, ça me va",
        "L'âge n'a pas trop d'importance",
        "Je suis open à tout"
      ]
    },
    "payment": {
      "title": "Tu serais d'accord pour payer les services d'un site de rencontre ?",
      "answers": [
        "Absolument pas",
        "Ça dépend des fonctionnalités",
        "Oui",
        "Difficile à dire"
      ]
    },
    "important": {
      "title": "Qu'est-ce qui compte le plus pour toi sur un site de rencontre ?",
      "subtitle": "Tu peux choisir plusieurs réponses",
      "answers": [
        "Les prix",
        "Le nombre de fonctionnalités",
        "La simplicité de l'interface",
        "Je ne sais pas trop"
      ]
    },
    "faith": {
      "title": "À quel point une foi partagée est-elle importante pour toi dans une relation ?",
      "answers": [
        "🙏 Très importante",
        "🤍 Importante, mais pas indispensable",
        "🌿 Les croyances différentes ne me posent pas de problème"
      ]
    },
    "share": {
      "title": "Qu'aimerais-tu le plus partager avec ton partenaire ?",
      "answers": [
        "🙏 La prière et la croissance spirituelle",
        "⛪ La vie d'Église et de communauté",
        "🤍 L'attention et le soutien au quotidien",
        "🏡 Les traditions et valeurs familiales"
      ]
    },
    "distance": {
      "title": "Tu préfères rencontrer quelqu'un près de chez toi ?",
      "answers": [
        "📍 Oui, plutôt près de chez moi",
        "🌍 Plus loin, ça me va aussi"
      ]
    },
    "next": "Suivant",
    "loader": [
      "Analyse de tes réponses…",
      "Comparaison des applis de rencontre…",
      "Préparation de ton résultat…"
    ],
    "final": {
      "title": "Voici ce qu'on te recommande :",
      "cta": "Visiter Kismia"
    },
    "shortFinal": {
      "title": "Découvre la suite ! 🎉",
      "subtitle": "Tes réponses ont été traitées !",
      "cta": "Continuer"
    },
    "footer": {
      "about": "À propos de nous",
      "privacy": "Politique de confidentialité",
      "terms": "Conditions d'utilisation"
    }
  },
  "pl": {
    "welcome": {
      "subtitle": "Rozwiąż ten 60-sekundowy quiz i znajdź aplikację randkową dopasowaną do ciebie",
      "cta": "Rozpocznij quiz",
      "laurels": [
        "Wybór redakcji",
        "Wybór użytkowników",
        "Najlepszy wybór"
      ],
      "ofTheYear": "roku"
    },
    "header": {
      "unlock": {
        "title": "Twoja idealna aplikacja randkowa czeka w środku 🔒",
        "subtitle": "Odpowiedz na kilka pytań, aby ją odblokować"
      },
      "ready": {
        "title": "Twój wynik jest prawie gotowy 🎉",
        "subtitle": "Przygotowujemy twój wynik"
      }
    },
    "dating_experience": {
      "title": "Czy masz doświadczenie w randkowaniu online?",
      "subtitle": "Możesz to zmienić później",
      "answers": [
        "Nie",
        "Tak"
      ]
    },
    "nearby": {
      "title": "Wolisz poznać kogoś w swojej okolicy?",
      "subtitle": "Możesz to zmienić później",
      "answers": [
        "Nie",
        "Tak"
      ]
    },
    "goal": {
      "title": "Czego szukasz?",
      "subtitle": "Możesz to zmienić później",
      "answers": [
        "Flirt i dobra zabawa",
        "Nowe przyjaźnie",
        "Znalezienie drugiej połówki",
        "Poznawanie osób w moim wieku",
        "Jeszcze nie wiem"
      ]
    },
    "age_difference": {
      "title": "Czy różnica wieku ma dla ciebie znaczenie?",
      "subtitle": "Możesz to zmienić później",
      "answers": [
        "Wolę kogoś w podobnym wieku",
        "Niewielka różnica wieku mi nie przeszkadza",
        "Wiek nie ma większego znaczenia",
        "Nie mam żadnych ograniczeń"
      ]
    },
    "payment": {
      "title": "Czy płatne funkcje serwisu randkowego wchodzą w grę?",
      "answers": [
        "Zdecydowanie nie",
        "Zależy od funkcji",
        "Tak",
        "Trudno powiedzieć"
      ]
    },
    "important": {
      "title": "Co jest dla ciebie najważniejsze w serwisie randkowym?",
      "subtitle": "Możesz wybrać więcej niż jedną odpowiedź",
      "answers": [
        "Ceny",
        "Liczba funkcji",
        "Wygodny interfejs",
        "Jeszcze nie wiem"
      ]
    },
    "faith": {
      "title": "Jak ważna jest dla ciebie wspólna wiara w związku?",
      "answers": [
        "🙏 Bardzo ważna",
        "🤍 Ważna, ale nie niezbędna",
        "🌿 Inne przekonania nie są dla mnie problemem"
      ]
    },
    "share": {
      "title": "Czym najbardziej chcesz dzielić się z partnerem?",
      "answers": [
        "🙏 Modlitwą i rozwojem duchowym",
        "⛪ Życiem kościoła i wspólnoty",
        "🤍 Codzienną troską i wsparciem",
        "🏡 Rodzinnymi tradycjami i wartościami"
      ]
    },
    "distance": {
      "title": "Wolisz poznać kogoś w swojej okolicy?",
      "answers": [
        "📍 Tak, najlepiej w okolicy",
        "🌍 Dalej też może być"
      ]
    },
    "next": "Dalej",
    "loader": [
      "Analizujemy twoje odpowiedzi…",
      "Porównujemy aplikacje randkowe…",
      "Przygotowujemy twój wynik…"
    ],
    "final": {
      "title": "Oto, co ci polecamy:",
      "cta": "Odwiedź Kismia"
    },
    "shortFinal": {
      "title": "Zobacz, co dalej! 🎉",
      "subtitle": "Twoje odpowiedzi zostały przetworzone!",
      "cta": "Dalej"
    },
    "footer": {
      "about": "O nas",
      "privacy": "Polityka prywatności",
      "terms": "Warunki korzystania"
    }
  },
  "pt": {
    "welcome": {
      "subtitle": "Faça este quiz de 60 segundos e descubra o app de namoro ideal pra você",
      "cta": "Começar o quiz",
      "laurels": [
        "Escolha do editor",
        "Escolha dos usuários",
        "Melhor escolha"
      ],
      "ofTheYear": "do ano"
    },
    "header": {
      "unlock": {
        "title": "Seu app de namoro perfeito está aqui dentro 🔒",
        "subtitle": "Responda algumas perguntas pra desbloquear"
      },
      "ready": {
        "title": "Seu resultado está quase pronto 🎉",
        "subtitle": "Preparando seu resultado"
      }
    },
    "dating_experience": {
      "title": "Você já tentou namoro online antes?",
      "subtitle": "Pode ser alterado depois",
      "answers": [
        "Não",
        "Sim"
      ]
    },
    "nearby": {
      "title": "Você prefere conhecer alguém por perto?",
      "subtitle": "Pode ser alterado depois",
      "answers": [
        "Não",
        "Sim"
      ]
    },
    "goal": {
      "title": "O que você está procurando?",
      "subtitle": "Pode ser alterado depois",
      "answers": [
        "Flertar e me divertir",
        "Fazer novas amizades",
        "Encontrar alguém para a vida",
        "Conhecer pessoas da minha idade",
        "Não sei ainda"
      ]
    },
    "age_difference": {
      "title": "A diferença de idade importa pra você?",
      "subtitle": "Pode ser alterado depois",
      "answers": [
        "Prefiro alguém perto da minha idade",
        "Uma pequena diferença de idade não tem problema",
        "A idade não importa muito",
        "Topo qualquer coisa"
      ]
    },
    "payment": {
      "title": "Você pagaria pelos serviços de um site de namoro?",
      "answers": [
        "De jeito nenhum",
        "Depende dos recursos",
        "Sim",
        "Difícil dizer"
      ]
    },
    "important": {
      "title": "O que mais importa pra você em um site de namoro?",
      "subtitle": "Você pode escolher várias respostas",
      "answers": [
        "Preços",
        "Quantidade de recursos",
        "Praticidade da interface",
        "Não tenho certeza ainda"
      ]
    },
    "faith": {
      "title": "Para você, qual é a importância de compartilhar a mesma fé em um relacionamento?",
      "answers": [
        "🙏 Muito importante",
        "🤍 Importante, mas não essencial",
        "🌿 Tenho a mente aberta para outras crenças"
      ]
    },
    "share": {
      "title": "O que você mais gostaria de compartilhar com um parceiro?",
      "answers": [
        "🙏 Oração e crescimento espiritual",
        "⛪ Vida de igreja e comunidade",
        "🤍 Cuidado e apoio no dia a dia",
        "🏡 Tradições e valores da família"
      ]
    },
    "distance": {
      "title": "Você prefere conhecer alguém por perto?",
      "answers": [
        "📍 Sim, de preferência por perto",
        "🌍 Mais longe também serve"
      ]
    },
    "next": "Próximo",
    "loader": [
      "Analisando suas respostas…",
      "Comparando apps de namoro…",
      "Preparando seu resultado…"
    ],
    "final": {
      "title": "Aqui está o que recomendamos pra você:",
      "cta": "Visitar o Kismia"
    },
    "shortFinal": {
      "title": "Veja o que vem a seguir! 🎉",
      "subtitle": "Suas respostas foram processadas!",
      "cta": "Continuar"
    },
    "footer": {
      "about": "Sobre nós",
      "privacy": "Política de Privacidade",
      "terms": "Termos de Uso"
    }
  },
  "ru": {
    "welcome": {
      "subtitle": "Пройди этот 60-секундный квиз и найди приложение для знакомств, которое подходит именно тебе",
      "cta": "Начать квиз",
      "laurels": [
        "Выбор редакции",
        "Выбор пользователей",
        "Лучший выбор"
      ],
      "ofTheYear": "года"
    },
    "header": {
      "unlock": {
        "title": "Твое идеальное приложение для знакомств уже внутри 🔒",
        "subtitle": "Ответь на несколько вопросов, чтобы открыть его"
      },
      "ready": {
        "title": "Твой результат почти готов 🎉",
        "subtitle": "Готовим твой результат"
      }
    },
    "dating_experience": {
      "title": "У тебя уже был опыт онлайн-знакомств?",
      "subtitle": "Можно изменить позже",
      "answers": [
        "Нет",
        "Да"
      ]
    },
    "nearby": {
      "title": "Хочешь встретить кого-то поблизости?",
      "subtitle": "Можно изменить позже",
      "answers": [
        "Нет",
        "Да"
      ]
    },
    "goal": {
      "title": "Что ты ищешь?",
      "subtitle": "Можно изменить позже",
      "answers": [
        "Флирт и развлечения",
        "Новые друзья",
        "Поиск спутника жизни",
        "Знакомства с ровесниками",
        "Пока не знаю"
      ]
    },
    "age_difference": {
      "title": "Важна ли для тебя разница в возрасте?",
      "subtitle": "Можно изменить позже",
      "answers": [
        "Предпочитаю кого-то своего возраста",
        "Небольшая разница — это нормально",
        "Возраст не так важен",
        "Меня устроит любой вариант"
      ]
    },
    "payment": {
      "title": "Будешь ли ты платить за услуги сайта знакомств?",
      "answers": [
        "Точно нет",
        "Зависит от функций",
        "Да",
        "Сложно сказать"
      ]
    },
    "important": {
      "title": "Что для тебя важнее всего на сайте знакомств?",
      "subtitle": "Можно выбрать несколько ответов",
      "answers": [
        "Цены",
        "Количество функций",
        "Удобство интерфейса",
        "Еще не знаю"
      ]
    },
    "faith": {
      "title": "Насколько важна для тебя общая вера в отношениях?",
      "answers": [
        "🙏 Очень важна",
        "🤍 Важна, но не обязательна",
        "🌿 Разные убеждения — не проблема"
      ]
    },
    "share": {
      "title": "Чем тебе больше всего хочется делиться с партнёром?",
      "answers": [
        "🙏 Молитвой и духовным ростом",
        "⛪ Церковной и общинной жизнью",
        "🤍 Повседневной заботой и поддержкой",
        "🏡 Семейными традициями и ценностями"
      ]
    },
    "distance": {
      "title": "Хочешь встретить кого-то поблизости?",
      "answers": [
        "📍 Да, лучше поблизости",
        "🌍 Можно и подальше"
      ]
    },
    "next": "Далее",
    "loader": [
      "Анализируем твои ответы…",
      "Сравниваем приложения для знакомств…",
      "Готовим твой результат…"
    ],
    "final": {
      "title": "Вот что мы рекомендуем тебе:",
      "cta": "Перейти на Kismia"
    },
    "shortFinal": {
      "title": "Узнай, что дальше! 🎉",
      "subtitle": "Твои ответы обработаны!",
      "cta": "Продолжить"
    },
    "footer": {
      "about": "О проекте",
      "privacy": "Политика конфиденциальности",
      "terms": "Условия использования"
    }
  },
  "uk": {
    "welcome": {
      "subtitle": "Пройди цей 60-секундний квіз і знайди застосунок для знайомств, який підходить саме тобі",
      "cta": "Почати квіз",
      "laurels": [
        "Вибір редакції",
        "Вибір користувачів",
        "Найкращий вибір"
      ],
      "ofTheYear": "року"
    },
    "header": {
      "unlock": {
        "title": "Твій ідеальний застосунок для знайомств чекає всередині 🔒",
        "subtitle": "Дай відповідь на кілька запитань, щоб його відкрити"
      },
      "ready": {
        "title": "Твій результат майже готовий 🎉",
        "subtitle": "Готуємо твій результат"
      }
    },
    "dating_experience": {
      "title": "Чи був у тебе досвід онлайн-знайомств?",
      "subtitle": "Це можна змінити пізніше",
      "answers": [
        "Ні",
        "Так"
      ]
    },
    "nearby": {
      "title": "Хочеш знайомитися з кимось поблизу?",
      "subtitle": "Це можна змінити пізніше",
      "answers": [
        "Ні",
        "Так"
      ]
    },
    "goal": {
      "title": "Що ти шукаєш?",
      "subtitle": "Це можна змінити пізніше",
      "answers": [
        "Флірт і розваги",
        "Нові друзі",
        "Пошук супутника життя",
        "Знайомства з людьми мого віку",
        "Ще не знаю"
      ]
    },
    "age_difference": {
      "title": "Чи має для тебе значення різниця у віці?",
      "subtitle": "Це можна змінити пізніше",
      "answers": [
        "Віддаю перевагу людям свого віку",
        "Невелика різниця у віці — це нормально",
        "Вік не має великого значення",
        "Без обмежень"
      ]
    },
    "payment": {
      "title": "Чи будеш ти платити за послуги сайту знайомств?",
      "answers": [
        "Точно ні",
        "Залежить від функцій",
        "Так",
        "Важко сказати"
      ]
    },
    "important": {
      "title": "Що для тебе найважливіше на сайті знайомств?",
      "subtitle": "Можна вибрати кілька відповідей",
      "answers": [
        "Ціни",
        "Кількість функцій",
        "Зручний інтерфейс",
        "Ще не знаю"
      ]
    },
    "faith": {
      "title": "Наскільки важлива для тебе спільна віра у стосунках?",
      "answers": [
        "🙏 Дуже важлива",
        "🤍 Важлива, але не обов’язкова",
        "🌿 Різні переконання — не проблема"
      ]
    },
    "share": {
      "title": "Чим тобі найбільше хочеться ділитися з партнером?",
      "answers": [
        "🙏 Молитвою та духовним зростанням",
        "⛪ Церковним і громадським життям",
        "🤍 Щоденною турботою та підтримкою",
        "🏡 Сімейними традиціями та цінностями"
      ]
    },
    "distance": {
      "title": "Хочеш знайомитися з кимось поблизу?",
      "answers": [
        "📍 Так, краще поблизу",
        "🌍 Можна й подалі"
      ]
    },
    "next": "Далі",
    "loader": [
      "Аналізуємо твої відповіді…",
      "Порівнюємо застосунки для знайомств…",
      "Готуємо твій результат…"
    ],
    "final": {
      "title": "Ось що ми рекомендуємо тобі:",
      "cta": "Перейти на Kismia"
    },
    "shortFinal": {
      "title": "Дізнайся, що далі! 🎉",
      "subtitle": "Твої відповіді опрацьовано!",
      "cta": "Продовжити"
    },
    "footer": {
      "about": "Про нас",
      "privacy": "Політика Конфіденційності",
      "terms": "Умови користування"
    }
  }
};

export default TEXTS;
